import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AccountService } from '../../services/AccountService';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private accountService: AccountService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const user = this.accountService.userValue;

    if (!user || !user.broker || user.broker.Id <= 0) {
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return of(false);
    }

    const hasRequiredResources = route.data.requiredResources
        ? this.userIsAuthorized(user.broker.AspNetRoles, route.data.requiredResources)
        : true;

    const routeAuthCheck$ = route.data.requireAuthorization
        ? this.isAuthorizedByRoute(route) // should return Observable<boolean>
        : of(true);

    return routeAuthCheck$.pipe(
        map(routeAuthorized => {
            const fullyAuthorized = hasRequiredResources && routeAuthorized;
            if (!fullyAuthorized) {
                this.router.navigate(['/unauthorized']);
            }
            return fullyAuthorized;
        })
    );
}


    userIsAuthorized(userResources: any, requiredResources: any[]): boolean {
        let hasRequiredResource = true;
        if (requiredResources && requiredResources.length > 0) {
            for (var i = 0; i < requiredResources.length; i++) {

                let index = userResources.findIndex(userResource => userResource == requiredResources[i]);

                if (index < 0) {
                    hasRequiredResource = false;
                    i = requiredResources.length;
                }

            }

        }
        return hasRequiredResource;
    }

    isAuthorizedByRoute(route): Observable<boolean> {
    if (route.routeConfig?.path) {
        switch (route.routeConfig.path) {
            case 'user/edit/:id': {
                const profileId = parseInt(route.params.id);
                return this.accountService.CanEditProfile(profileId);
            }
            case 'resource/new': {
                return of(this.accountService.CanAddResource());
            }
            case 'resource/edit/:id': {
                return of(this.accountService.CanEditResource());
            }
            case 'member/edit/:id': {
                const memberId = parseInt(route.params.id);
                return of(this.accountService.CanEditMember(memberId));
            }
        }
    }
    return of(false);
}

}
